/* Klaviyo popup com gatilho do tema (custom trigger): não abre para quem chegou com cupom bloqueado. Sem dependências.
   Base: guia "Shopify + Klaviyo: bloquear o popup pelos seis cupons definidos"; acrescentado: 7 dias sem reabrir depois
   de abrir/fechar e 365 dias depois de inscrever (as regras que o formulário tinha no Klaviyo), e leitura do cupom salvo (utmsTrack). */
(function () {
  'use strict';
  if (window.__klaviyoPromoGateLoaded) return;
  window.__klaviyoPromoGateLoaded = true;

  var cfg = window.KlaviyoPromoGateConfig;
  if (!cfg || !cfg.enabled) return;

  function log(message) {
    if (cfg.debug && window.console) console.info('[KlaviyoPromoGate]', message);
  }
  if (!/^[A-Za-z0-9]{6}$/.test(cfg.formId) || cfg.formId === 'FORMID') { log('ID do formulário inválido. Nada será aberto.'); return; }
  if (['session', 'cookie'].indexOf(cfg.blockStorage) < 0) { log('blockStorage inválido. Nada será aberto.'); return; }
  if (!Array.isArray(cfg.blockRules) || !cfg.blockRules.length ||
      !cfg.blockRules.every(function (rule) {
        return rule && typeof rule.param === 'string' && rule.param.length > 0 &&
          Array.isArray(rule.values) && rule.values.length > 0 &&
          rule.values.every(function (value) { return typeof value === 'string' && value.length > 0; });
      })) { log('Regras de bloqueio inválidas. Nada será aberto.'); return; }
  if (typeof cfg.delayMs !== 'number' || cfg.delayMs < 0 ||
      typeof cfg.sdkWaitMs !== 'number' || cfg.sdkWaitMs <= 0 ||
      typeof cfg.dismissDays !== 'number' || cfg.dismissDays < 0 ||
      typeof cfg.submitDays !== 'number' || cfg.submitDays < 0 ||
      typeof cfg.readExistingContext !== 'function' ||
      typeof cfg.extraEligibility !== 'function' ||
      !Array.isArray(cfg.excludedUrlContains) ||
      !cfg.excludedUrlContains.every(function (value) { return typeof value === 'string' && value.length > 0; }) ||
      (cfg.blockStorage === 'cookie' && (typeof cfg.blockCookieHours !== 'number' || cfg.blockCookieHours < 0))) {
    log('Prazos inválidos. Nada será aberto.'); return;
  }

  var keyBase = 'klaviyo_promo_gate_v1_' + cfg.formId;
  var blockKey = keyBase + '_blocked';
  var frequencyKey = keyBase + '_attempted';
  var dismissKey = keyBase + '_dismissed';
  var submitKey = keyBase + '_submitted';
  var memoryBlocked = false;
  var memoryAttempted = false;
  var storageHealthy = true;
  var pendingTimer = null;
  var privacyLoading = false;
  var observedHref = window.location.href;
  var startedAt = Date.now();

  function matches(value, rule) {
    return rule.values.some(function (expected) {
      if (cfg.caseSensitive) return String(value) === expected;
      return String(value).toLowerCase() === expected.toLowerCase();
    });
  }
  function queryIsBlocked(search) {
    var params = new URLSearchParams(search || '');
    return cfg.blockRules.some(function (rule) {
      return params.getAll(rule.param).some(function (value) { return matches(value, rule); });
    });
  }
  function inspectCurrentUrl() {
    if (queryIsBlocked(window.location.search)) memoryBlocked = true;
  }
  memoryBlocked = queryIsBlocked(window.__klaviyoPromoGateEntrySearch);
  inspectCurrentUrl();

  function sessionGet(key) {
    try { return window.sessionStorage.getItem(key); }
    catch (error) { storageHealthy = false; log('sessionStorage indisponível. Bloqueio preventivo.'); return null; }
  }
  function sessionSet(key) {
    try {
      window.sessionStorage.setItem(key, '1');
      if (window.sessionStorage.getItem(key) !== '1') throw new Error('write failed');
    } catch (error) { storageHealthy = false; log('Falha ao persistir estado. Bloqueio preventivo.'); }
  }
  function cookieGet(key) {
    try {
      var entry = document.cookie.split(';').map(function (s) { return s.trim(); })
        .find(function (s) { return s.indexOf(key + '=') === 0; });
      return entry ? entry.slice(key.length + 1) : null;
    } catch (error) { storageHealthy = false; return null; }
  }
  function cookieSet(key, hours) {
    try {
      var attributes = '; Path=/; SameSite=Lax';
      if (window.location.protocol === 'https:') attributes += '; Secure';
      if (hours > 0) attributes += '; Max-Age=' + Math.floor(hours * 3600);
      if (cfg.blockCookieDomain) attributes += '; Domain=' + cfg.blockCookieDomain;
      document.cookie = key + '=1' + attributes;
      if (cookieGet(key) !== '1') throw new Error('write failed');
    } catch (error) { storageHealthy = false; log('Cookie não pôde ser gravado. Bloqueio preventivo.'); }
  }
  function readBlock() {
    return (cfg.blockStorage === 'cookie' ? cookieGet(blockKey) : sessionGet(blockKey)) === '1';
  }
  function persistBlock() {
    if (!readBlock()) {
      if (cfg.blockStorage === 'cookie') cookieSet(blockKey, cfg.blockCookieHours);
      else sessionSet(blockKey);
    }
  }
  function privacyAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === true;
    } catch (error) { return false; }
  }
  function loadPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) return;
    if (privacyLoading || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    privacyLoading = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) { log('API de privacidade não carregou. Nada será aberto.'); return; }
        evaluate();
      });
    } catch (error) { log('Falha ao inicializar privacidade. Nada será aberto.'); }
  }
  function inspectExistingContext() {
    try {
      var context = cfg.readExistingContext();
      if (!context) return;
      cfg.blockRules.forEach(function (rule) {
        var value = context[rule.param];
        if (value !== undefined && value !== null && matches(value, rule)) memoryBlocked = true;
      });
    } catch (error) { storageHealthy = false; log('Falha ao ler o cupom salvo. Bloqueio preventivo.'); }
  }
  function cancelTimer() {
    if (pendingTimer !== null) { window.clearTimeout(pendingTimer); pendingTimer = null; }
  }
  function mayOpen() {
    inspectCurrentUrl();
    if (!privacyAllowed()) return false;
    inspectExistingContext();
    if (memoryBlocked) persistBlock();
    if (memoryBlocked || readBlock()) return false;
    if (cookieGet(submitKey) === '1' || cookieGet(dismissKey) === '1') return false;
    if (sessionGet(frequencyKey) === '1' || memoryAttempted) return false;
    if (!storageHealthy || !cfg.reviewedExistingRules) return false;
    if (cfg.excludedUrlContains.some(function (text) { return window.location.href.indexOf(text) >= 0; })) return false;
    if (/\/(cart|checkout|checkouts|account|orders)(\/|$)/i.test(window.location.pathname)) return false;
    if (window.Shopify && window.Shopify.designMode) return false;
    try {
      return cfg.extraEligibility({ pathname: window.location.pathname, search: window.location.search, href: window.location.href }) === true;
    } catch (error) { log('Erro na regra extra. Nada será aberto.'); return false; }
  }
  function requestOpen() {
    pendingTimer = null;
    if (!mayOpen()) return;
    if (!window._klOnsite || typeof window._klOnsite.openForm !== 'function' || typeof window._klOnsite.push !== 'function') {
      if (Date.now() - startedAt < cfg.delayMs + cfg.sdkWaitMs) pendingTimer = window.setTimeout(requestOpen, 250);
      else log('Klaviyo.js não ficou pronto no prazo. Sem abertura nesta página.');
      return;
    }
    if (document.visibilityState === 'hidden') return;
    sessionSet(frequencyKey);
    if (!storageHealthy) return;
    memoryAttempted = true;
    log('Solicitando abertura do formulário elegível.');
    try { window._klOnsite.push(['openForm', cfg.formId]); }
    catch (error) { log('SDK recusou abertura. Sem repetição automática nesta aba.'); }
  }
  function evaluate() {
    loadPrivacy();
    if (!mayOpen()) { cancelTimer(); return; }
    if (pendingTimer !== null) return;
    var remainingDelay = Math.max(0, cfg.delayMs - (Date.now() - startedAt));
    pendingTimer = window.setTimeout(requestOpen, remainingDelay);
  }

  window.addEventListener('klaviyoForms', function (event) {
    if (!event.detail || String(event.detail.formId) !== cfg.formId) return;
    var type = event.detail.type;
    if (['open', 'close', 'submit'].indexOf(type) >= 0) {
      memoryAttempted = true;
      cancelTimer();
      if (privacyAllowed()) {
        sessionSet(frequencyKey);
        // 7 dias sem reabrir contados a partir de quando o popup ABRE (o evento close não disparou nos testes de 12/10).
        if ((type === 'open' || type === 'close') && cfg.dismissDays > 0 && cookieGet(dismissKey) !== '1') cookieSet(dismissKey, cfg.dismissDays * 24);
        if (type === 'submit' && cfg.submitDays > 0) cookieSet(submitKey, cfg.submitDays * 24);
      }
      log('Evento do formulário: ' + type);
    }
  });
  document.addEventListener('visitorConsentCollected', evaluate);
  document.addEventListener('visibilitychange', evaluate);
  window.addEventListener('pageshow', evaluate);
  window.addEventListener('popstate', evaluate);
  window.KlaviyoPromoGate = {
    refresh: evaluate,
    status: function () {
      return {
        formId: cfg.formId,
        memoryBlocked: memoryBlocked,
        persistedBlock: readBlock(),
        dismissed: cookieGet(dismissKey) === '1',
        submitted: cookieGet(submitKey) === '1',
        marketingAllowed: privacyAllowed(),
        storageHealthy: storageHealthy,
        rulesReviewed: cfg.reviewedExistingRules,
        memoryAttempted: memoryAttempted
      };
    }
  };
  window.setInterval(function () {
    if (window.location.href !== observedHref) { observedHref = window.location.href; evaluate(); }
    else if (!(window.Shopify && window.Shopify.customerPrivacy) && Date.now() - startedAt < cfg.sdkWaitMs) evaluate();
  }, 500);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', evaluate, { once: true });
  else evaluate();
}());
